import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Grid, Typography, Box, Paper, Card, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';

import logo from "../Assets/Images/logo.webp";
import envelopeBg from "../Assets/Images/Envelope.jpg";

const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(3),
  margin: theme.spacing(1),
  width: '100%',
  maxWidth: '300px',
  height: '120px',
  fontSize: '1.2rem',
  textTransform: 'none',
  borderRadius: '12px',
  background: '#f8f9fa',
  color: '#465064',
  boxShadow: '0 2px 8px rgba(70, 80, 100, 0.1)',
  transition: 'all 0.2s ease',
  border: '1px solid #e9ecef',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(70, 80, 100, 0.15)',
    background: '#ffffff',
  },
}));

const Dashboard = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Orientation',
      icon: '📱',
      description: 'QR Code & Media Center',
      path: '/qr'
    },
    {
      title: 'Meeting',
      icon: '🤝',
      description: 'Schedule & Manage Meetings',
      path: '/meeting'
    },
    {
      title: 'Leads',
      icon: '👥',
      description: 'View Your Leads',
      path: '/leads'
    },
    {
      title: 'Other',
      icon: '⚙️',
      description: 'Additional Services',
      path: '/other'
    }
  ];

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      background: '#f8f9fa',
      py: 4,
      px: { xs: 2, sm: 3, md: 4 }
    }}>
      <Container maxWidth="lg" sx={{ 
        background: 'white',
        borderRadius: 2,
        boxShadow: '0 2px 8px rgba(70, 80, 100, 0.1)',
        overflow: 'hidden',
        p: { xs: 2, md: 3 }
      }}>
        {/* Header Section */}
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            mb: 4,
            background: '#465064',
            padding: '3rem 2rem',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(70, 80, 100, 0.1)',
            position: 'relative',
            overflow: 'hidden',
            minHeight: '250px',
          }}
        >
          <Box sx={{ position: 'relative', zIndex: 2, width: '100%', textAlign: 'center' }}>
            <Card sx={{ 
              display: 'inline-block',
              p: 2,
              borderRadius: 2,
              background: '#465064',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              mb: 2
            }}>
              <img 
                src={logo} 
                alt="Company Logo" 
                style={{ 
                  width: '150px', 
                  height: 'auto'
                }} 
              />
            </Card>
            {/* <Typography 
              variant="h2" 
              component="h1" 
              gutterBottom 
              align="center"
              sx={{
                color: 'white',
                fontWeight: 600,
                mb: 1,
                fontSize: { xs: '2rem', md: '2.5rem' }
              }}
            >
              NAJMA
            </Typography> */}
            <Typography 
              variant="h6" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.8)',
                fontWeight: 400
              }}
            >
              Welcome to our comprehensive platform
            </Typography>
          </Box>
        </Box>

        {/* Menu Section */}
        <Box sx={{ mb: 3 }}>
          <Typography 
            variant="h4" 
            sx={{ 
              textAlign: 'center',
              mb: 3,
              fontWeight: 600,
              color: '#465064'
            }}
          >
            Choose Your Service
          </Typography>
        </Box>

        <Grid container spacing={3} justifyContent="center">
          {menuItems.map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card 
                elevation={0} 
                sx={{ 
                  p: 1, 
                  borderRadius: '12px',
                  background: 'transparent',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                  }
                }}
              >
                <StyledButton
                  variant="contained"
                  onClick={() => navigate(item.path)}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    padding:10
                  }}
                >
                  <Typography variant="h1" sx={{ fontSize: '2rem', mb: 1 }}>
                    {item.icon}
                  </Typography>
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      fontWeight: 600,
                      mb: 1
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      textAlign: 'center',
                      fontWeight: 400,
                      opacity: 0.8
                    }}
                  >
                    {item.description}
                  </Typography>
                </StyledButton>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Footer Section */}
        <Box sx={{ 
          mt: 4, 
          pt: 3, 
          borderTop: '1px solid #e9ecef',
          textAlign: 'center'
        }}>
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#6c757d',
              fontWeight: 400,
              opacity: 0.7
            }}
          >
            © 2024 NAJMA. All rights reserved. | Professional Real Estate Solutions
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Dashboard; 